export var TimePeriod;
(function (TimePeriod) {
    TimePeriod[TimePeriod["OVERALL"] = 0] = "OVERALL";
    TimePeriod[TimePeriod["SEVEN_DAYS"] = 1] = "SEVEN_DAYS";
    TimePeriod[TimePeriod["ONE_MONTH"] = 2] = "ONE_MONTH";
    TimePeriod[TimePeriod["THREE_MONTHS"] = 3] = "THREE_MONTHS";
    TimePeriod[TimePeriod["SIX_MONTHS"] = 4] = "SIX_MONTHS";
    TimePeriod[TimePeriod["TWELVE_MONTHS"] = 5] = "TWELVE_MONTHS";
})(TimePeriod || (TimePeriod = {}));
const labels = {
    [TimePeriod.OVERALL]: "Overall",
    [TimePeriod.SEVEN_DAYS]: "7 days",
    [TimePeriod.ONE_MONTH]: "1 month",
    [TimePeriod.THREE_MONTHS]: "3 months",
    [TimePeriod.SIX_MONTHS]: "6 months",
    [TimePeriod.TWELVE_MONTHS]: "12 months",
};
const values = {
    [TimePeriod.OVERALL]: "overall",
    [TimePeriod.SEVEN_DAYS]: "7day",
    [TimePeriod.ONE_MONTH]: "1month",
    [TimePeriod.THREE_MONTHS]: "3month",
    [TimePeriod.SIX_MONTHS]: "6month",
    [TimePeriod.TWELVE_MONTHS]: "12month",
};
export function timePeriodToLabel(timePeriod) {
    return labels[timePeriod];
}
export function timePeriodToValue(timePeriod) {
    return values[timePeriod];
}
export function parseTimePeriod(timePeriod) {
    return TimePeriod[timePeriod];
}
export function getTimePeriods() {
    return Object.keys(TimePeriod).filter(key => isNaN(Number(key))).map(string => parseTimePeriod(string));
}
